export default "__VITE_ASSET__0XuMPNqYNXuWJL$eu$YoOQ__"